import { SelectOption } from '@rio-cloud/rio-uikit/Select';
import { ChargeAndGoCardRepresentation } from './ChargeAndGoCardRepresentation';
import { useMemo } from 'react';
import { useAvailableChargeAndGoCards } from '../../../../../state/paymentPartners/useAvailableChargeAndGoCards';

import { CardSelectionDropdown } from './CardSelectionDropdown';
import { CustomFormattedMessage } from '../../../../../i18n/i18n';
import {
  chargeAndGoLink,
  openInNewTab,
} from '../../../../../configuration/partnerLinks';
import { useLocale } from '../../../../../i18n/locale';

export const ChargeAndGoCardForm = () => {
  const cardsResponse = useAvailableChargeAndGoCards();

  const cardOptions: SelectOption[] = useMemo(() => {
    return cardsResponse.availableCards.map((c) => ({
      id: c.referenceId,
      label: <ChargeAndGoCardRepresentation card={c} />,
    }));
  }, [cardsResponse.availableCards]);

  return (
    <CardSelectionDropdown
      isLoading={cardsResponse.isLoading}
      options={cardOptions}
      errorContent={cardsResponse.error ? <CardsErrorMessage /> : null}
      noCardsContent={
        !cardsResponse.error && cardOptions.length === 0 ? (
          <NoCardsFoundMessage />
        ) : null
      }
    />
  );
};

const CardsErrorMessage = () => (
  <CustomFormattedMessage
    id={'onboarding.dialog.serviceCardForm.cardList.technicalError'}
    values={{ paymentPartner: 'MAN Charge&Go' }}
  />
);

const NoCardsFoundMessage = () => {
  const { locale } = useLocale();

  return (
    <div
      className="cursor-pointer"
      data-testid={'onboarding-dialog-charge-and-go-explanation-link'}
      onClick={() => {
        openInNewTab(chargeAndGoLink(locale));
      }}
    >
      <CustomFormattedMessage
        id={'onboarding.dialog.serviceCardForm.chargeAndGo.noCards'}
      />
    </div>
  );
};
